import Image from 'next/image';

import { Button } from '../../../ui';
export const Confirmation = ({
  handleCloseModal,
}: {
  handleCloseModal: () => void;
}) => {
  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-4 items-center">
        <span className="text-text-secondary max-w-[640px] text-center">
          Your Supplier Request has been successfully submitted to Scaleup. We
          will carefully review your requirements and connect you with three
          supplier candidates who best match your needs. Please keep an eye on
          your email inbox and the Scaleup platform for updates. Once we have
          identified suitable supplier candidates, you&apos;ll receive further
          instructions on how to proceed.
        </span>
        <Button
          suffixIcon="/icons/arrow_right.svg"
          text="Go Home"
          variant="primary"
          onClick={handleCloseModal}
        />
      </div>
      <div className="flex justify-center">
        <Image
          src="/confirmation_sr.png"
          alt="Confirmation"
          width={1024}
          height={300}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </div>
  );
};
